// extracted by mini-css-extract-plugin
export var slide_show_container = "SlideShow-module--slide_show_container--2A5ij";
export var ss_outer = "SlideShow-module--ss_outer--2pB04";
export var slide_show_img = "SlideShow-module--slide_show_img--1DR7x";
export var pi_container = "SlideShow-module--pi_container--1o1r0";